
<template>
  <div>
    <v-toolbar flat color="white">
      <v-toolbar-title>Usuários</v-toolbar-title>
      <v-spacer></v-spacer>

      <UserFormDlg
        :dialog="frmUserDialog"
        :addButton="usersPermissions && usersPermissions.edit"
        :openForm="() => openDialogForm()"
        :closeForm="() => closeDialogForm()"
        :saveUser="(data) => saveUser(data)"
        :editFormData="formData"
      />
    </v-toolbar>
    <SearchUsers :searchUsers="(user) => getUsers(user)" />
    <v-data-table :headers="headers" :items="tableData">
      <template v-slot:items="props">
        <tr
          @mouseover="props.item.hover = true"
          @mouseout="props.item.hover = false"
        >
          <td class="text-xs-center">
            <v-icon color="success" v-if="props.item.active"
              >check_circle</v-icon
            >
            <v-icon color="error" v-if="!props.item.active">block</v-icon>
          </td>
          <td class="text-xs-left">
            {{ props.item.name }}
            <br />
            <small>{{ props.item.accountable }}</small>
          </td>
          <td class="text-xs-left">
            {{ props.item.document | formatCnpjCpf }}
          </td>
          <td class="text-xs-center posRelative">
            {{ props.item.updated_at | moment("DD/MM/YYYY") }}
            <div
              class="px-4 text-xs-center layout trControls"
              v-show="props.item.hover"
            >
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-icon
                    v-on="on"
                    v-if="usersPermissions.edit"
                    small
                    class="mr-2"
                    @click="editItem(props.item)"
                    >edit</v-icon
                  ></template
                >
                <span>Editar</span>
              </v-tooltip>
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-icon
                    v-on="on"
                    v-if="usersPermissions.view"
                    small
                    class="mr-2"
                    @click="editItem(props.item, 'viewForm')"
                    >remove_red_eye</v-icon
                  ></template
                >
                <span>Visualizar</span>
              </v-tooltip>
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-icon
                    v-on="on"
                    small
                    class="mr-2"
                    @click="confirmToogleStatusItem(props.item)"
                    v-if="
                      !props.item.active &&
                      usersPermissions &&
                      usersPermissions.edit
                    "
                    >check</v-icon
                  ></template
                >
                <span>Ativar</span>
              </v-tooltip>
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-icon
                    v-on="on"
                    small
                    class="mr-2"
                    @click="confirmToogleStatusItem(props.item)"
                    v-if="
                      props.item.active &&
                      usersPermissions &&
                      usersPermissions.edit
                    "
                    >block</v-icon
                  ></template
                >
                <span>Desativar</span>
              </v-tooltip>
              <!-- <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-icon
                    v-on="on"
                    v-if="usersPermissions.remove"
                    small
                    @click="confirmDelUser(props.item)"
                    >delete</v-icon
                  ></template
                >
                <span>Excluir</span>
              </v-tooltip> -->
            </div>
          </td>
        </tr>
      </template>
      <template v-slot:no-data>
        <p>Não há dados</p>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import UserFormDlg from '@/components/users/UsersForm.vue'
import SearchUsers from '@/components/users/SearchUsers.vue'
import {
  users as usersService,
  addUser as addUserService,
  updateUser as updateUserService,
  toggleStatus as toggleService,
  deleteUser as deleteUserService
} from '@/services/users'

const requestToSaveUser = {
  post: addUserService,
  patch: updateUserService
}

export default {
  name: 'Users',

  components: {
    UserFormDlg,
    SearchUsers
  },

  data () {
    return {
      frmUserDialog: false,
      formData: null,
      headers: [
        {
          text: 'Status',
          align: 'center',
          sortable: true,
          value: 'active'
        },
        { text: 'Nome/Razão social', sortable: true, value: 'name' },
        { text: 'CPF/CNPJ', value: 'document', sortable: false },
        {
          text: 'Última alteração',
          value: 'updated_at',
          sortable: false,
          align: 'center'
        }
      // ,
      // { text: " ", value: "", sortable: false, align: "center" }
      ],
      tableData: []
    }
  },

  mounted () {
    this.getUsers()
  },

  computed: {
    usersPermissions () {
      return this.$store.state.permissions.permissions.users
    }
  },

  methods: {
    confirmDelUser (data) {
      let obj = {
        message: `Você deseja excluir o usuário "${data.name}"?`,
        title: 'Excluir usuário',
        callback: (_) => {
          this.delUser(data)
        },
        type: 'warning',
        btConfirm: { name: 'Sim', show: true },
        btCancel: { name: 'Não', show: true }
      }
      this.$store.commit('confirmMessage/showConfirmMessage', obj)
    },

    async delUser (data) {
      await deleteUserService(data.id)

      let opts = {
        message: `Usuário removido com sucesso`,
        type: 'success'
      }

      this.$store.commit('showAlert', opts)
      this.getUsers()
    },

    confirmToogleStatusItem (data) {
      let action = data.active ? 'desativar' : 'ativar'
      let obj = {
        message: `Você deseja ${action} o usuário "${data.name}"?`,
        title: `${data.active ? 'Desativar usuário' : 'Ativar usuário'}`,
        callback: (_) => {
          this.toogleStatusItem(data)
        },
        type: 'warning',
        btConfirm: { name: 'Sim', show: true },
        btCancel: { name: 'Não', show: true }
      }
      this.$store.commit('confirmMessage/showConfirmMessage', obj)
    },

    async toogleStatusItem (user) {
      await toggleService(user.id)

      let opts = {
        message: `Status modificado com sucesso`,
        type: 'success'
      }
      this.$store.commit('showAlert', opts)
      this.getUsers()
    },

    openDialogForm () {
      this.formData = null
      this.frmUserDialog = true
    },

    closeDialogForm () {
      this.frmUserDialog = false
    },

    async getUsers (user = '') {
      this.$store.commit('showLoader', {
        circle: true
      })

      const dataSearch = {
        ...user
      }

      this.tableData = await usersService(dataSearch)

      this.$store.commit('hideLoader')
    },

    editItem (item, view) {
      if (!item.condominium_id) {
        item.condominium_id = item.condominium.map((cond) => {
          return cond.id
        })
      }

      view === 'viewForm' ? (item.view = true) : (item.view = false)

      this.formData = Object.assign({}, item)
      this.frmUserDialog = true
    },

    async saveUser (user) {
      this.$store.commit('showLoader', {
        circle: true
      })
      const requestMethod = user.id ? 'patch' : 'post'

      await requestToSaveUser[requestMethod](user)

      this.showAlert(user.id || '')

      this.frmUserDialog = false
      this.getUsers()

      this.$store.commit('hideLoader')
    },

    showAlert (id) {
      let opts = {
        message: `Usuário ${id ? 'alterado' : 'adicionado'} com sucesso`,
        type: 'success'
      }
      this.$store.commit('showAlert', opts)
    }
  },

  filters: {
    formatCnpjCpf (value) {
      if (value.length > 11) {
        value = value.replace(
          /^([0-9]{2})([0-9]{3})([0-9]{3})([0-9]{4})([0-9]{2})$/,
          '$1.$2.$3/$4-$5'
        )
      } else {
        value = value.replace(
          /^([0-9]{3})([0-9]{3})([0-9]{3})([0-9]{2})$/,
          '$1.$2.$3-$4'
        )
      }
      return value
    }
  }
}
</script>

<style>
</style>
